import React from "react";
import { GatsbyImage } from "gatsby-plugin-image";
import Link from "../Link";
import CampaignStatusBadge from "../CampaignStatusBadge";

const CampaignCard = ({ campaign, timezone, campaignStatus }) => {
  return (
    <div className="campaign__card col-md-6 col-lg-4 my-4 d-flex align-items-stretch">
      <Link to={`/campaigns/${campaign.slug}`} className="card shadow rounded">
        <div className="position-relative">
          <GatsbyImage
            image={
              campaign.featuredImage.node.localFile.childImageSharp
                .gatsbyImageData
            }
            className="card-img-top"
            alt={campaign.slug}
          />
          <CampaignStatusBadge
            campaignStatus={campaignStatus}
            styles={{ position: "absolute", top: "8%", right: "7%" }}
          />
        </div>
        <div
          className="card-body w-100 shadow rounded-bottom"
          style={{
            color: "#152b43",
            position: "relative",
          }}
        >
          <div
            style={{
              width: "100%",
              backgroundColor: "#ffffff",
            }}
          >
            <h5
              className="mt-1 mb-2"
              dangerouslySetInnerHTML={{
                __html: campaign.title,
              }}
            />
            <span>
              {`${campaign.acfCampaignDate.campaignStartDate} - ${campaign.acfCampaignDate.campaignEndDate} (${timezone.offset})`}
            </span>
          </div>
        </div>
      </Link>
    </div>
  );
};

export default CampaignCard;
